import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { Payment } from '@app/shared/models/payment';
import { PaymentType } from '@app/shared/models/payment-type';
import { PaymentReceiver } from '@app/shared/models/payment-receiver';
import { DrCurrencyFormat, DrI18nService } from '@app/core/services/i18n/i18n.service';
import { CurrencyService } from '@app/core/services/currency.service';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';

export interface PaymentDialogData {
    payment?: Payment;
    paymentTypes: PaymentType[];
    paymentReceivers: PaymentReceiver[];
}

@Component({
    templateUrl: './payment-dialog.component.html',
    styleUrls: ['./payment-dialog.component.scss']
})
export class PaymentDialogComponent extends BaseComponent
                                    implements OnInit {

    private _paymentTypeSelectIsOpen: boolean;

    set paymentTypeSelectIsOpen(open: boolean) {
        this._paymentTypeSelectIsOpen = open;
    }

    public payment: Payment;

    public filteredPaymentTypes: string[];
    public receiverFieldDisabled = false;

    get currency(): DrCurrencyFormat {
        return this.currencyService.activeCurrency;
    }

    constructor(public dialogRef: MatDialogRef<ConfirmModalComponent>,
                protected currencyService: CurrencyService,
                @Inject(MAT_DIALOG_DATA) public data: PaymentDialogData) {
        super();
        this._idPrefix = 'payment_dialog.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.payment = new Payment(this.data.payment);
        this.updatePaymentTypeList(this.payment.type);
        this.updateReceiverField(this.payment);
    }

    protected filter(list: DisplayName[], value: any, type?: string): string[] {
        const filterValue = value ? value.toLowerCase() : value;
        return list ? list.filter((option: DisplayName) => {
            return option.displayName.toLowerCase().includes(filterValue);
        }).map((option: DisplayName) => {
            return option.displayName;
        }) : [];
    }

    public updatePaymentTypeList(value: any): void {
        this.filteredPaymentTypes = this.filter(this.data.paymentTypes, value);
    }

    public updateReceiverField(payment: Payment): void {
        this.receiverFieldDisabled = false;

        const paymentType = this.data.paymentTypes && this.data.paymentTypes.find((v: PaymentType) => v.displayName === payment.type);
        if (paymentType) {
            this.payment.receiver = paymentType.receiver;
            this.receiverFieldDisabled = true;
        }
    }

    public onBlurPaymentType(payment: Payment): void {
        if (!this._paymentTypeSelectIsOpen) {
            this.updateReceiverField(payment);
        }
    }

    public accept(): void {
        this.payment.booking_date = DrI18nService.dateTimeToDateOnlyString(this.payment.booking_date as Date);
        this.payment.payment_target = DrI18nService.dateTimeToDateOnlyString(this.payment.payment_target as Date);

        this.dialogRef.close(this.payment);
    }

    public close(): void {
        this.dialogRef.close(false);
    }

}
